import { render, staticRenderFns } from "./UserEditPrivacy.vue?vue&type=template&id=7fad70cf&"
import script from "./UserEditPrivacy.vue?vue&type=script&lang=js&"
export * from "./UserEditPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports